module.exports = __webpack_public_path__ + "img/slide2.9eb0ed73.jpg";